import { Input, OnInit, OnDestroy, Output, EventEmitter, Directive } from '@angular/core';
import { takeWhile } from 'rxjs/operators';

// Abstracts
import { NgPostTypeProvider } from './post-type-provider.abstract';
import { NgRefreshService } from './refresh-service.abstract';

// Interfaces
import { IPostTypeProviderOptions, IPostType } from 'projects/models/src/public-api';

@Directive()
export abstract class NgPostTypeCollectionComponent<T extends IPostType> implements OnInit, OnDestroy {

    @Input() title: string;
    @Input() endpoint: string;
    @Input() options: IPostTypeProviderOptions<T> = { page: 1, per_page: 10 };
    @Input() loadMoreOnScroll = true;

    @Output() refreshCompleted = new EventEmitter<boolean>();
    @Output() selected = new EventEmitter<T>();

    public data: T[] = new Array<T>(3);
    public endOfList = false;

    private alive = true;
    private loadMoreEvent: any = null;

    constructor(
      protected dataProvider: NgPostTypeProvider<T>,
      protected refreshService: NgRefreshService) {}

    ngOnInit() {
        if (this.endpoint) {
            this.getData(this.endpoint);
            this.refreshListener();
        }
    }

    ngOnDestroy() {
        this.alive = false;
    }

    private refreshListener() {
        this.refreshService.status
            .pipe(takeWhile(() => this.alive))
            .subscribe((status) => {
                if (status) {
                    this.options.page = 1;
                    this.getData(this.endpoint, true);
                }
            });
    }

    public getData(endpoint: string, refresh?: boolean){
        this.dataProvider.get('' + endpoint, this.options)
            .pipe(takeWhile(() => this.alive))
            .subscribe((data: T[]) => {
                if (this.options.page === 1) { this.data = data; }
                else { this.data = [...this.data, ...data]; }

                this.endOfList = data.length < this.options.per_page;

                if (this.loadMoreEvent !== null) {
                    this.loadMoreEvent.target.complete();
                    this.loadMoreEvent.target.disabled = this.endOfList;
                }

                if (refresh) { this.refreshCompleted.emit(true); }
            });
    }

    public loadMore(event: any) {
        this.loadMoreEvent = event;
        this.options.page++;
        this.getData(this.endpoint);
    }

    public select(x: T) {
        this.selected.emit(x);
    }

}
